import { Injectable } from '@angular/core';

/**
 * MessageService to present messages to users
 */
@Injectable({
  providedIn: 'root'
})
export class MessageService {

  messages: object[] = [];

  constructor() { }

  /**
   * add
   * @param message - Message to add
   * @param status - Status can be one of: success, info, warning, error
   */
  add(message: string, status: string) {
    // Translate status into awesome font fa-* icons
    let icon = 'info';
    if (status === 'error') {
      icon = 'ban';
      status = 'danger';
    } else if (status === 'warning') {
      icon = 'exclamation-triangle';
    } else if (status === 'success') {
      icon = 'check';
    } else {
      icon = 'info';
    }
    const msg = {message, status, icon};
    this.messages.push(msg);
  }

  clear() {
    this.messages = [];
  }

}
